import cityList from "./json/cityList";

let initialState = {
    preloader: {
        display: true
    },
    select: {
        cityList,
        selectedCity:  '706483'
    },
    currentWeatherData: null,
    forecastWeatherData: null,
    weatherIcon: {
        imgLoaded: false,
        frames:  [3, 6],
        imgList: [
            {
                name: '01d',
                position: [0, 2]
            },
            {
                name: '01n',
                position: [0, 3]
            },
            {
                name: '02d',
                position: [0, 4]
            },
            {
                name: '02n',
                position: [0, 5]
            },
            {
                name: '03d',
                position: [0, 0]
            },
            {
                name: '03n',
                position: [0, 1]
            },
            {
                name: '04d',
                position: [1, 0]
            },
            {
                name: '04n',
                position: [1, 1]
            },
            {
                name: '09d',
                position: [1, 2]
            },
            {
                name: '09n',
                position: [1, 3]
            },
            {
                name: '10d',
                position: [1, 4]
            },
            {
                name: '10n',
                position: [1, 5]
            },
            {
                name: '11d',
                position: [2, 5]
            },
            {
                name: '11n',
                position: [2, 0]
            },
            {
                name: '13d',
                position: [2, 1]
            },
            {
                name: '13n',
                position: [2, 2]
            },
            {
                name: '50d',
                position: [2, 3]
            },
            {
                name: '50n',
                position: [2, 4]
            }
        ]
    },
    defaultSettings: {
        units: 'metric',
        lang: 'ru',
        appId: 'a0416a16e90dab631a9188513a26d825',
        host: 'https://api.openweathermap.org/data/2.5/'
    },
    error: false
};

export default initialState;